import React, { useContext } from 'react'
import { FaCheckCircle, FaRegCircle } from "react-icons/fa";
import { Context } from '../Context/Context';
// import Search from '../Components/Images/search-lg.svg'
// import Bell from '../Components/Images/bell-01.svg'
import Add from '../Components/Images/AddBtn.svg'
import { useLocation, useNavigate } from 'react-router-dom';

const CreateAcct = ({ NumberOfUserAcct, verified, NumberOfBeneficiaryAcct, NumberOfInvoices, UserProfile }) => {
    const location = useLocation()

    const navigate = useNavigate()

    const {
        handleAcctBar,
        acctBar,
    } = useContext(Context)

    const isVerified = () => {
        if (!verified) {
            navigate('/dashboard', {
                replace: true,
                state: {
                    error: 'You need to fill in your KYC data to continue',
                    from: location.pathname,
                },
            });
            return;
        }

        handleAcctBar();
    };

    const transactions = JSON.parse(localStorage.getItem('UserTransactions'))

    return (
        <div>
            <div
                className={`w-full top-0 h-[400%] z-20 absolute ${acctBar ? 'bg-black/30' : 'hidden'}`}
                onClick={handleAcctBar}
            ></div>
            <div className='flex items-start justify-between md:p-10 py-10 px-4 w-full'>
                <div>
                    <p className='text-[28px] font-semibold'>Home</p>
                    <p className='text-[16px] font-normal text-[#525154]'>Welcome back, {UserProfile.first_name}!</p>
                </div>
                <div className='flex md:items-center items-start gap-9'>
                    {/* <img className='lg:block hidden cursor-pointer' src={Search} alt="" />
                    <img className='lg:block hidden cursor-pointer' src={Bell} alt="" /> */}
                    <img onClick={handleAcctBar} className='w-10 cursor-pointer' src={Add} alt="" />
                </div>
            </div>
            <div className='flex flex-col items-center gap-9 bg-[#fbf9fd] lg:mx-10 mx-4 py-16 px-2 rounded-md border-2 border-black/50 border-dashed'>
                <div className='max-w-[500px]'>
                    <p className='text-center font-medium text-[19px] text-[#1D1C1F]'>We are here to help you get paid for your work.</p>
                    <p className='text-center mt-1 text-[14px] font-normal text-[#525154]'>Get started by creating your first bank account for any supported country (e.g., USA, Canada, UK)</p>
                </div>
                <button
                    className="bg-[#531CB3] text-white p-3 text-[14px] rounded-lg"
                    onClick={isVerified}
                >
                    Create your first bank account
                </button>
            </div>
            <div className='mt-[45px] md:mx-10 mx-4'>
                <h1 className='font-medium text-[18px] text-[#1D1C1F]'>Congratulations on taking the first step!</h1>
                <p className='text-[#525154] text-[14px]'>Complete these simple steps to get started using reccur.</p>
                <div className='flex sm:flex-row flex-col mb-10 text-[14px] justify-between gap-4 w-[80%] mt-4'>
                    <div className='flex flex-col gap-4'>
                        <div
                            className={`flex items-center gap-2 cursor-pointer ${NumberOfUserAcct > 0 ? 'text-black/50 line-through' : 'text-[#542d9d] underline'}`}
                            onClick={() => {
                                if (NumberOfUserAcct === 0) {
                                    handleAcctBar()
                                }
                            }}
                        >
                            {NumberOfUserAcct > 0 ? (
                                <FaCheckCircle className='mt-1 text-[#542d9d]' />
                            ) : (
                                <FaRegCircle className='mt-1 text-black/50' />
                            )}
                            <p>Create your first bank account</p>
                        </div>
                        <div
                            className={`flex items-center gap-2 cursor-pointer ${NumberOfInvoices > 0 ? 'text-black/50 line-through' : 'text-[#542d9d] underline'}`}
                            onClick={() => {
                                if (NumberOfInvoices === 0) {
                                    navigate('/invoices');
                                }
                            }}
                        >
                            {NumberOfInvoices > 0 ? (
                                <FaCheckCircle className='mt-1 text-[#542d9d]' />
                            ) : (
                                <FaRegCircle className='mt-1 text-black/50' />
                            )}
                            <p>Create your first invoice</p>
                        </div>
                    </div>
                    <div className='flex flex-col gap-4'>
                        <div
                            className={`flex items-center gap-2 cursor-pointer ${NumberOfBeneficiaryAcct > 0 ? 'text-black/50 line-through' : 'text-[#542d9d] underline'}`}
                            onClick={() => {
                                if (NumberOfBeneficiaryAcct === 0) {
                                    navigate('/beneficiaries');
                                }
                            }}
                        >
                            {NumberOfBeneficiaryAcct > 0 ? (
                                <FaCheckCircle className='mt-1 text-[#542d9d]' />
                            ) : (
                                <FaRegCircle className='mt-1 text-black/50' />
                            )}
                            <p>Add your first beneficiary</p>
                        </div>
                        <div
                            className={`flex items-center gap-2 cursor-pointer ${transactions?.length > 0 ? 'text-black/50 line-through' : 'text-[#542d9d] underline'}`}
                            onClick={() => {
                                if (transactions?.length === 0) {
                                    handleAcctBar()
                                }
                            }}
                        >
                            {transactions?.length > 0 ? (
                                <FaCheckCircle className='mt-1 text-[#542d9d]' />
                            ) : (
                                <FaRegCircle className='mt-1 text-black/50' />
                            )}
                            <p>Make your first withdrawal</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateAcct